import "@fontsource-variable/hanken-grotesk";
import "@fontsource/instrument-serif";
import "./styles/theme.css";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";

const container = document.getElementById("root");
if (!container) throw new Error("#root element missing in index.html");
createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
